/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
import { useEffect } from 'react';
// next
import { Box, Card, Container, Grid } from '@mui/material';
import { useDispatch } from '../../../../redux/store';

// @mui
import { styled } from '@mui/material/styles';
import ExerciseIDE from '../../../../sections/exercise/ExerciseIDE';

import { useSelector } from 'react-redux';
import Page from '../../../../components/Page';
import Layout from '../../../../layouts';
import { setCommentSearch } from '../../../../redux/slices/blog/blog.comment';
import { setSolution } from '../../../../redux/slices/hackerthon/hackerthon.solution';
import ExerciseTab from '../../../../sections/exercise/ExerciseTab';
import SolutionDetail from '../../../../sections/exercise/SolutionDetail';
import { getSolutionBySlugAPI } from '../../../../service/hackerthon/hackerthon.solution.service';
// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  paddingBottom: theme.spacing(10),
  paddingTop: theme.spacing(10),
  [theme.breakpoints.up('md')]: {
    paddingTop: theme.spacing(12),
  },
}));

const TabPanelStyle = styled(Box)(({ theme }) => ({
  height: `calc(100vh - 152px)`,
  display: 'flex',
  [theme.breakpoints.down('sm')]: {
    height: '60vh'
  },
}));

SolutionDetailPage.getLayout = function getLayout(page) {
  return <Layout variant="fullscreen">{page}</Layout>;
};

export default function SolutionDetailPage({ solution }) {
  const dispatch = useDispatch();
  const { search: searchComment } = useSelector((state) => state.blogComment);

  useEffect(() => {
    dispatch(setSolution(solution));
    dispatch(setCommentSearch({ ...searchComment, value: '', page: 0, filterBys: { itemId: solution.id, type: "SOLUTION" } }));
  }, [solution]);

  return (
    <Page title={solution.title} description={solution.title} >
      <RootStyle>
        <Container maxWidth={false} sx={{ px: { md: 1 } }}>
          <Grid container spacing={1} >
            <Grid item xs={12} sm={6}>
              <Card variant="outlined" sx={{ borderRadius: 1 }}>
                <ExerciseTab exercise={solution.exercise} tab="solutions" />
                <TabPanelStyle>
                  <SolutionDetail />
                </TabPanelStyle>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6}>
              <ExerciseIDE />
            </Grid>
          </Grid>
        </Container>
      </RootStyle>
    </Page>
  );
}

export async function getStaticPaths() {
  const paths = [{ params: { slug: '/test', id: '/test' } }];
  return { paths, fallback: 'blocking' };
}

export async function getStaticProps({ params }) {
  const { id } = params;

  const { code: status, data: solution } = await getSolutionBySlugAPI(id);

  if (status !== '200') {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      solution
    },
  };
}
